import { IItinerarymap } from "@eventr/common";

export interface PartitionedItineraries {
  visible: IItinerarymap[];
  hidden: IItinerarymap[];
}

/**
 * Splits the itinerary map on the per-user `hidden` flag the itinerary map endpoint sets.
 * Filtering here means every screen reading `itineraryMap` follows. The guest share path
 * sets no flag, and absent means visible.
 */
export const partitionHiddenItineraries = (map: IItinerarymap[]): PartitionedItineraries => {
  const visible: IItinerarymap[] = [];
  const hidden: IItinerarymap[] = [];

  for (const itin of map) {
    if (!itin) continue;
    (itin.hidden ? hidden : visible).push(itin);
  }

  return { visible, hidden };
};
